import React, { useEffect } from 'react'
import Home from './vitews/Home';
import './assets/style/index.scss';

function App() {
  const resizeRem = () => {
    const width = document.documentElement.clientWidth
    if (width >= 1150) {
      document.documentElement.style.fontSize = `${width / 14.4}px`
    } else {
      document.documentElement.style.fontSize = `${1440 / 14.4}px`
    }
    
  }
  useEffect(() => {
    resizeRem()
    window.addEventListener('resize', () => resizeRem())
    return () => {
      window.removeEventListener('resize', () => resizeRem())
    }
  }, [])
  return (
    <div className="app-wapper">
      <Home />
    </div>
  );
}

export default App;
